/* set todays venue(s) and menu */

const venues = {
    "victoriaPark": {
        "label": "Victoria Park Market",
        "img": {
            "src": "https://pbs.twimg.com/media/GfeMllVX0AAlsjo.jpg",
            "alt": "Victoria Park Market"
        },
        "map": {
            "googleMaps": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2086.971413265212!2d-0.05006296653053528!3d51.534471425705995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761cdf949e0d99%3A0x7e03df044150bcb6!2sVictoria%20Park%20Market!5e0!3m2!1sen!2suk!4v1741208953800!5m2!1sen!2suk"
        }
    },
    "placeholder": {
        "label": "Market - Test Placeholder",
        "img": {
            "src": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Hackneytownhall2.jpg/1280px-Hackneytownhall2.jpg",
            "alt": "Test Placeholder"
        },
        "map": {
            "googleMaps": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.139339162167!2d-0.059217073202455166!3d51.54734392182245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761cfacf6a8eaf%3A0xd0a2073ac7b93eea!2sHackney%20Central%20station!5e0!3m2!1sen!2suk!4v1745959362341!5m2!1sen!2suk"
        }
    }
}

export const todaysVenues = [
    {
        "venue": venues.placeholder,
        "day": "Sunday",
        "date": "08/03/26",
        "start": "11:30",
        "end": "20:00"
    }
];

export const menu = [
    
    {
        "id": 1,
        "name": "Fat Tony Pepperoni",
        "description": "Our signature tomato base sauce, Pecorino Romano Cheese, Fior Di Latte Mozzarella Cheese, Smokey Roni (Pepperoni). Finished with fresh basil leaves.",
        "price": 13,
        // "image": "https://fornopiombo.com/cdn/shop/articles/How-to-Make-Neapolitan-Pizza-At-Home.jpg?v=1654552141",
        "image": "/img/fat-tony-pepperoni.jpg",
        "active": true,
        "spicy": false,
        "vegetarian": false,
        "veganOption": false, 
        "allergens": "Wheat, Milk"
    },
    {
        "id": 2,
        "name": "Margherita",
        "description": "Our signature tomato base sauce, Oregano, Garlic, Pecorino Romano Cheese, Fior Di Latte Mozzarella Cheese. Finished with fresh basil leaves.All of our cheese is vegetarian.For the Vegan version - please select vegan cheese option",
        "price": 10.5,
        // "image": "https://www.seriouseats.com/thmb/ev6cOMD0Snv3ExveXwktlsSqryc=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/__opt__aboutcom__coeus__resources__content_migration__serious_eats__slice.seriouseats.com__images__2011__07__20110722-pizzarte-primary-1511f8a6ca324412ad69bff0c2c2bc67.jpg",
        "image": "/img/Margareta.jpg",
        "active": true,
        "vegetarian": true,
        "veganOption": true, 
        "spicy": false,
        "allergens": "Wheat, Milk (non-vegan cheeses only)"
    },
    {
        "id": 3,
        "name": "Nduja",
        "description": "Our signature tomato base sauce, Pecorino Romano Cheese, Fior Di Latte Mozzarella Cheese, Spicy Nduja (italian sausage), Red Onion. Finished with Fresh Basil Leaves. For the Vegan version - please select vegan cheese option.",
        "price": 12.5,
        "image": "/img/NDJUA.jpg",
        "active": true,
        "vegetarian": true,
        "veganOption": true, 
        "spicy": false,
        "allergens": "Wheat, Milk (non-vegan cheeses only)"
    },
    {
        "id": 4,
        "name": "House Of Crust Hot Stuff",
        "description": "Our signature tomato base sauce, Pecorino Romano Cheese, Fior Di Latte Mozzarella Cheese, Smokey Roni (Pepperoni), Spicy Nduja (italian sausage). Finished with a drizzle of Hot Honey and Fresh Basil Leaves.",
        "price": 13.5,
        // "image": "https://tarateaspoon.com/wp-content/uploads/2022/11/Neapolitan-pizza-dough-web-sq-480x270.jpeg",
        "image": "/img/HOC-Hotstuff.jpg",
        "active": true,
        "veganOption": false,
        "vegetarian": false, 
        "spicy": true,
        "allergens": "Wheat, Milk, Hot Honey Drizzle - may contain: Gluten, eggs, nuts, peanuts, fish, mustard, celery, milk, sesame, sulphites, soy."
    },
    {
        "id": 5,
        "name": "Sir Oinks Alot",
        "description": "Our signature tomato base sauce, Oregano, Garlic, Pecorino Romano Cheese, Fior Di Latte Mozzarella Cheese, Roast Romano Peppers. Finished with Mortadella Con Pistachio, nut free basil pesto and pistachio.",
        "price": 12.5,
        // "image": "https://www.thechoppingblock.com/hs-fs/hubfs/Blog/Burrata_and_Balsamic.jpg?width=900&height=600&name=Burrata_and_Balsamic.jpg",
        "image": "/img/SirOinksALot.png",
        "active": false,
        "spicy": false,
        "vegetarian": false,
        "veganOption": false,
        "allergens": "Wheat, Milk, Nuts (Pistachio)" 
    },
    {
        "id": 6,
        "name": "House Of Crust Veggie / Vegan Special",
        "description": "Roasted peppers, imported italian Kalamata olives, mushrooms, red onions, mozzarella, pecorino romano, oregano, fresh basil, traditional San Marzano tomato sauce",
        "price": 12.5,
        // "image": "https://cloveandcumin.com/wp-content/uploads/2023/03/Neapolitan-Pizza-at-Home.jpg",
        "image": "/img/Veggie-Vegan-Special.jpg",
        "active": true,
        "veganOption": true, 
        "vegetarian": true,
        "spicy": false,
        "allergens": "Wheat, Milk (non-vegan cheeses only)"
    },
    {
        "id": 7,
        "name": "Marinana",
        "description": "Our signature tomato base sauce, Oregano, Garlic and finished with fresh basil leaves. The classic cheese free masterpiece.",
        "price": 9.5,
        "image": "/img/Marinara_v2.jpg",
        "active": true,
        "vegetarian": true,
        "veganOption": true, 
        "spicy": false,
        "allergens": "Wheat"
    },
];
